import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { FilterContainer, SearchContainer, StatusFilterSelect } from '../../../styles/UnitsMappingStyles';
import { T_KEYS } from '../../../constants';

interface FilterSectionProps {
  searchQuery: string;
  statusFilter: string;
  onSearchChange: (query: string) => void;
  onStatusFilterChange: (status: string) => void;
}

const FilterSection: React.FC<FilterSectionProps> = memo(({
  searchQuery,
  statusFilter,
  onSearchChange,
  onStatusFilterChange,
}) => {
  const { t } = useTranslation();

  return (
    <FilterContainer>
      <SearchContainer
        placeholder={t(T_KEYS.UNITS_MAPPING_SEARCH)}
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: 'rgba(10, 10, 10, 0.5)' }} />
            </InputAdornment>
          ),
        }}
        variant="outlined"
      />
      <StatusFilterSelect
        value={statusFilter}
        onChange={(e) => onStatusFilterChange(e.target.value)}
      >
        <option value="all">{t(T_KEYS.UNITS_MAPPING_FILTER_ALL)}</option>
        <option value="mapped">{t(T_KEYS.UNITS_MAPPING_FILTER_MAPPED)}</option>
        <option value="not_mapped">{t(T_KEYS.UNITS_MAPPING_FILTER_NOT_MAPPED)}</option>
      </StatusFilterSelect>
    </FilterContainer>
  );
});

FilterSection.displayName = 'FilterSection';

export default FilterSection;
